var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "url(#paint0_linear_12937_2255)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12937_2255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2484 10.5841C16.2484 8.23694 14.3456 6.33415 11.9984 6.33415C9.65116 6.33415 7.74837 8.23694 7.74837 10.5841V16.2508H16.2484V10.5841ZM17.665 16.7231L17.9484 17.1008C18.0657 17.2573 18.034 17.4793 17.8775 17.5966C17.8163 17.6426 17.7417 17.6675 17.665 17.6675H6.33171C6.13611 17.6675 5.97754 17.5089 5.97754 17.3133C5.97754 17.2367 6.00239 17.1621 6.04837 17.1008L6.33171 16.7231V10.5841C6.33171 7.45453 8.86876 4.91748 11.9984 4.91748C15.128 4.91748 17.665 7.45453 17.665 10.5841V16.7231ZM10.2275 18.3758H13.7692C13.7692 19.3538 12.9764 20.1466 11.9984 20.1466C11.0204 20.1466 10.2275 19.3538 10.2275 18.3758Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12937_2255",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47B5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#189AFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12937_2255"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(3.5 3.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.99f06728de4e0d21320c2aa19e5af44a.svg";
export { ForwardRef as ReactComponent };